import { AuthService } from './../services/auth.service';
import { Component, OnInit } from '@angular/core';
import {BlockUI, NgBlockUI} from "ng-block-ui";

@Component({
selector: 'app-account',
templateUrl: './account.component.html',
styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {

	role: string;

	@BlockUI() blockUI: NgBlockUI;

	constructor(
		private authService: AuthService
	) { 
	}

	ngOnInit(): void {
		this.getRole();
	}

	// get role of user
	getRole(): void {
		this.blockUI.start('Loading');
		
		const token = localStorage.getItem('token');
		
		this.authService.decodeJWT(token).subscribe(
			(res) => {
				if (res.success){
					this.role = res.data.role;
					this.blockUI.stop();
				} else{
					this.blockUI.stop();
				}
			},
			(error) => {
				this.blockUI.stop();
			}
		);
	}
}
